import { render, staticRenderFns } from "./StudyPlansTableTermsTeachingEffects.vue?vue&type=template&id=f2917352&"
import script from "./StudyPlansTableTermsTeachingEffects.vue?vue&type=script&lang=js&"
export * from "./StudyPlansTableTermsTeachingEffects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports